module.exports = __webpack_public_path__ + "static/media/photo-8.d59ae19b.avif";